export const AUTH_POPUP_WINDOW_FEATURES =
    'toolbar=no, menubar=no, width=600, height=630, top=100, left=100';
export const AUTH_POPUP_WINDOW_TARGET = 'Authenticate';
